import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MultivenueComponent } from './multivenue.component';
import { MultivenueItemComponent } from './multivenue-item/multivenue-item.component';
import { DropzoneModule } from '../directives/dropzone/dropzone.module';



@NgModule({
  declarations: [
    MultivenueComponent,
    MultivenueItemComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    DropzoneModule
  ],
  exports: [
    MultivenueComponent
  ]
})
export class MultivenueModule { }